import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledContainer = styled.div`
  max-width: 412px;
  animation: ${fadeIn} 0.5s 1.2s backwards;
`;

const textHighlightMixin = css`
  ${(props) =>
    props.highlightText
      ? css`
          display: inline-block;
          background: #ffffff;
          padding: 0 0.2em;
        `
      : ""}
`;

export const Title = styled.h1`
  color: #292929;
  font-weight: normal;
  margin: 0;
  ${textHighlightMixin}
`;

export const Description = styled.p`
  margin: 2em 0;
  font-size: 14px;
  line-height: 200%;
  color: #888888;
  ${textHighlightMixin}
`;
